module.exports = __webpack_public_path__ + "static/img/pic_09@2x.c7dd611f.png";